import axios from "api/axiosInstance";
import { TestExperiment, CreateExperimentDto, TestStatus } from "types/aiReviewTest";

interface ApiResponse<T> {
  error: number;
  data: T;
}

interface ExperimentListParams {
  status?: TestStatus;
  createdBy?: string;
  limit?: number;
  offset?: number;
}

interface ExperimentProgress {
  totalCount: number;
  completedCount: number;
  failedCount: number;
  status: TestStatus;
  percentage: number;
}

export const experimentApi = {
  // 실험 생성
  create: (data: CreateExperimentDto) =>
    axios.post<ApiResponse<TestExperiment>>("/api/v1/admin/ai-review-evaluation/experiments", data),

  // 실험 목록 조회
  findAll: (params?: ExperimentListParams) =>
    axios.get<ApiResponse<TestExperiment[]>>("/api/v1/admin/ai-review-evaluation/experiments", {
      params,
    }),

  // 실행 중인 실험 목록 조회
  findRunning: () =>
    axios.get<ApiResponse<TestExperiment[]>>(
      "/api/v1/admin/ai-review-evaluation/experiments/running"
    ),

  // 실험 상세 조회
  findOne: (id: number) =>
    axios.get<ApiResponse<TestExperiment>>(`/api/v1/admin/ai-review-evaluation/experiments/${id}`),

  // 실험 시작 또는 재시작
  start: (id: number, restart: boolean = false) =>
    axios.put<ApiResponse<TestExperiment>>(
      `/api/v1/admin/ai-review-evaluation/experiments/${id}/start`,
      {},
      {
        params: { restart },
      }
    ),

  // 실험 중단
  stop: (id: number) =>
    axios.put<ApiResponse<TestExperiment>>(
      `/api/v1/admin/ai-review-evaluation/experiments/${id}/stop`
    ),

  // 실험 진행 상황
  getProgress: (id: number) =>
    axios.get<ApiResponse<ExperimentProgress>>(
      `/api/v1/admin/ai-review-evaluation/experiments/${id}/progress`
    ),

  // 실험 결과 조회
  getResults: (id: number) =>
    axios.get<ApiResponse<any>>(`/api/v1/admin/ai-review-evaluation/experiments/${id}/results`),
};
